<template>
    <div class="card">
      <div class="card-body">
        <AjaxForm route="productBrand/Add">
        <div class="row">
          <div class="col-md-6">
            <CustomInput name="title" placeholder="عنوان را وارد کنید" type="text" label="عنوان"></CustomInput>
          </div>
          <div class="col-md-6">
            <CustomInput name="en_title" placeholder="عنوان انگلیسی را وارد کنید" type="text" label="عنوان انگلیسی"></CustomInput>
          </div>
          <div class="col-md-6">
            <CustomInput name="description" placeholder="توضیحات را وارد کنید" type="textarea" label="توضیحات برند"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <CustomInput :select_multiple="true" placeholder="صنف کاری را انتخاب کنید" label="صنف کاری" name="guild_ids[]" select-label="title" :select-options="select_guild_option"
                         :fetch-options="getGuildsForSelect"
                         v-model="guild"
                         reduce_select="_id" type="select"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <CustomInput placeholder="کشور را انتخاب کنید" label="کشور برند" name="country_id" select-label="name" :select-options="country_options"
                         :fetch-options="getCountryForSelect"
                         v-model="country"
                         reduce_select="_id" type="select"></CustomInput>
          </div>
          <div class="col-md-3 d-flex">
            <label class="mr-4">تصویر</label>
            <ImagePicker name="pic_id"></ImagePicker>
          </div>
          <div class="col-md-3 d-flex">
            <label class="mr-4">تصویر بسته بندی</label>
            <ImagePicker name="box_pic_id"></ImagePicker>
          </div>
        </div>
          <div class="row">
            <div class="col-8 col-sm-8 col-md-5 mx-auto mt-4">
              <button class="btn btn-info btn-block">افزودن برند</button>
            </div>
          </div>
        </AjaxForm>
      </div>

    </div>
</template>

<script>
import vSelect from 'vue-select'
import MasterLayout from "@/components/MasterLayout";
import CustomInput from "@/components/CustomInput";
import AjaxForm from "@/components/forms/AjaxForm";
import Loading from "@/components/Loading";
import ImagePicker from "@/components/ImagePicker";
import {mapActions} from "vuex";
import {ProductApi} from "@/api/ProductApi";
import {AppApi} from "@/api/AppApi";
export default {
  name: "AddProductBrand",
  components: {ImagePicker, Loading, AjaxForm, CustomInput, MasterLayout,vSelect},
  data(){
    return {
      select_guild_option : [],
      guild : null,
      country_options:[],
      country : null,
    }
  },
  async mounted()
  {
    this.setPageTitle('افزودن محصول');
    this.setShowHead(true);
  },
  methods : {
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    async getGuildsForSelect(search,loading)
    {
      loading(true);
      if (search.length)
      {
        const data = await ProductApi.getGuildForSelectAjax(search);
        if (data.ok)
        {
          this.select_guild_option = data.guilds;
        }
        else
          this.select_guild_option = [];
      }
      loading(false);
    },
    async getCountryForSelect(search,loading)
    {
      loading(true);
      if (search.length)
      {
        const data = await AppApi.getCountryForSelectAjax(search);
        if (data.ok)
        {
          this.country_options = data.countries;
        }
        else
          this.country_options = [];
      }
      loading(false);
    },
  },

}
</script>

<style scoped>

</style>
